module.exports = __webpack_public_path__ + "img/workshop.65be01bc.svg";